

export default function TeamCoaches ({ data }) {

    if (!data) return;

    let coachA, coachB;

    try {
        const coachAData = data.eventParticipants[0]?.lineup.coaches?.players?.[0];
        const coachBData = data.eventParticipants[1]?.lineup.coaches?.players?.[0];
        const coachAName = coachAData?.listName;
        const coachBName = coachBData?.listName;
        const coachATeamLogoPath = `https://static.flashscore.com/res/image/data/${coachAData?.teamLogo[0]?.path}`;
        const coachBTeamLogoPath = `https://static.flashscore.com/res/image/data/${coachBData?.teamLogo[0]?.path}`;
        coachA = {
            name: coachAName,
            teamLogoPath: coachATeamLogoPath,
        };
        coachB = {
            name: coachBName,
            teamLogoPath: coachBTeamLogoPath,
        };
    } catch (error) {
        console.error('Ошибка обработки данных о тренерах:', error);
        return;
    }

    if (!coachA || !coachB) return;

    return (
        <div className="team-coaches">
            <div className="table">
                <div className="table__row table__header">
                    <div className="table__col">
                        Тренеры
                    </div>
                </div>
                <div className="table__row">
                    <div className="table__col table__col--grow">
                        <div className="team-coaches__coach">
                            <img src={coachA.teamLogoPath} alt="" />
                            <span>{coachA.name}</span>
                        </div>
                    </div>
                    <div className="table__col table__col--grow" style={{
                        'justifyContent': 'flex-end',
                    }}>
                        <div className="team-coaches__coach team-coaches__coach--reversed">
                            <img src={coachB.teamLogoPath} alt="" />
                            <span>{coachB.name}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};